/**
 * Items as a sentence names them: "A", "A and B", "A, B and C", with no
 * serial comma, as the app's copy writes lists. With `max`, a longer list
 * names the first `max` items and counts the rest: "A, B, C and 2 more".
 */
export function listInWords(
  items: readonly string[],
  { max }: { max?: number } = {}
): string {
  const named =
    max != null && items.length > max
      ? [...items.slice(0, max), `${items.length - max} more`]
      : items;
  return named.length <= 1
    ? (named[0] ?? '')
    : `${named.slice(0, -1).join(', ')} and ${named.at(-1)!}`;
}
